import { useCallback } from 'react'
import type { MutationHook } from '@commerce/utils/types'
import { CommerceError } from '@commerce/utils/errors'
import useSetNewPassword, { UseSetNewPassword } from '@commerce/auth/use-setNewPassword'
import type { SetNewPasswordHook } from '../types/setNewPassword'
import useCustomer from '../customer/use-customer'

import {
  setCustomerToken,
  throwUserErrors,
  customerResetByUrlMutation
} from '../utils'
import { Mutation, MutationCustomerRecoverArgs } from '../schema'

export default useSetNewPassword as UseSetNewPassword<typeof handler>

export const handler: MutationHook<SetNewPasswordHook> = {
  fetchOptions: {
    query: customerResetByUrlMutation
  },
  async fetcher({
                  input: { password, resetUrl },
                  options,
                  fetch
                }) {
    if (!(password)) {
      throw new CommerceError({
        message:
          'A password is required to reset password'
      })
    }

    const { customerResetByUrl } = await fetch<Mutation,
      MutationCustomerRecoverArgs>({
      ...options,
      variables: {
          password,
          resetUrl,
      }
    })

    throwUserErrors(customerResetByUrl?.customerUserErrors)

    return null
  },
  useHook: ({ fetch }) => () => {
    const { mutate } = useCustomer()

    return useCallback(
      async function setNewPassword(input) {
        const data = await fetch({ input })
        await mutate()
        return data
      },
      [fetch, mutate]
    )
  }
}
